import React from "react";
import PropTypes from "prop-types";
import { Card, Table, Select, Row, Col, InputNumber } from "antd";
import { CONSTITUTION_TYPES } from "constants/enums";

class CibilParamTable extends React.Component {
    
    state = {
        updateCibilParamData: []
    }

    dataSource = {
        "cibil_parameter": [{
            "associate_id": 1234,
            "associate_name": "Shivam tiwari",
            "parameter": [{ "parameter": "ADCV", "value": "True", "associate_id": 1234 }, { "parameter": "ADsssCV", "value": "True", "associate_id": 1234 }]
        },{
            "associate_id": 12345,
            "associate_name": "Vibhor Mishra",
            "parameter": [{ "parameter": "ADCV", "value": "True", "associate_id": 12345 }, { "parameter": "ADsssCV", "value": "True", "associate_id": 12345 }]
        }],
        "commercial_cibil": [{ "parameter": "commercial_cibil ADCV", "value": "True", "type": "testtype" }, { "parameter": "ADsssCV commercial_cibil", "value": "True", "test": "testttststst" }]
    };

    comercialColumns = [
        {
            title: "Parameter",
            dataIndex: "parameter",
            key: "parameter",
        },
        {
            title: "Value",
            dataIndex: "value",
            key: "value",
            render: (props, row) => (
                <Select key={"AB"} style={{minWidth : "70px"}} defaultValue={row.value} onChange={(value) => this.oncomercialValueSelect(props, row, value)}>
                    <Select.Option value={"Yes"}>Yes</Select.Option>
                    <Select.Option value={"No"}>No</Select.Option>
                </Select>
            ),
        }
    ];

    oncomercialValueSelect =(props, row, value)=>{
        let orginalData = this.props.cibilParamData;
        let data = this.props.cibilParamData["cibil_parameter"];
        data.filter((assoc) => assoc.associate_id == row.associate_id)[0].parameter.map((item) => {
            if(item.parameter == row.parameter){
                item.value = value;
            }
        });
        orginalData["cibil_parameter"] = data;
        this.setState({
            updateCibilParamData: orginalData  
        });
    }

    columns = [
        {
            title: "Parameter",
            dataIndex: "parameter",
            key: "parameter",
        },
        {
            title: "Value",
            dataIndex: "value",
            key: "value",
            render: (props, row) => (
                row.parameter.includes('Bad Debt') ? <InputNumber
                precision={0}
                defaultValue={row.value}
                placeholder=""
                onChange={(value) => this.onValueSelect(props, row, value)}
            /> : 
                <Select key={"AB"} style={{minWidth : "70px"}} defaultValue={row.value} onChange={(value) => this.onValueSelect(props, row, value)}>
                    <Select.Option value={"Yes"}>Yes</Select.Option>
                    <Select.Option value={"No"}>No</Select.Option>
                </Select>
            ),
        }
    ];

    onValueSelect =(props, row, value)=>{
        let orginalData = this.props.cibilParamData;
        let data = this.props.cibilParamData["commercial_cibil"];
        data.map((item) => {
            if(item.parameter == row.parameter){
                item.value = value;
            }
        });
        orginalData["commercial_cibil"] = data;
        this.setState({
            updateCibilParamData: orginalData  
        });
    }

    render() {
        const { company, caseDetails } = this.props;
        let cibil_parameter = this.props.cibilParamData && this.props.cibilParamData['cibil_parameter'];
        let commercial_cibil = this.props.cibilParamData && this.props.cibilParamData['commercial_cibil'];
        return (
            <React.Fragment>
                <Card title={"CIBIL Parameter"}
                    className={"padless-card small-card-title"}
                    extra={
                        <a
                            key={"icon"}
                            onClick={() => this.props.update(this.state.updateCibilParamData)}
                            disabled={this.props.recreditViewOnlyPermission}
                        >
                            {" "}
                            Update
                        </a> 
                    }>
                    <Row gutter={16}>
                        {
                            cibil_parameter?.map((item) => {
                                return (
                                    <Col className="gutter-row" span={24/(cibil_parameter.length)} key={item.associate_id}>
                                        <div key={item.associate_id}>
                                            <h3 style={{padding: "10px"}} key={item.associate_id}>{item.associate_name}</h3>
                                            <Table
                                                dataSource={item?.parameter}
                                                columns={this.comercialColumns}
                                                pagination={false}
                                            />
                                        </div>
                                    </Col>
                                );
                            })
                        }
                    </Row>
                </Card>
                {company &&
                    CONSTITUTION_TYPES.findKey(_ => _ === company.constitution) !== "Proprietorship" || caseDetails?.toJS()?.is_vendor_finance ?
                    <Card
                        title={"CIBIL Comercial"}
                        className={"padless-card small-card-title"}
                    >
                        <Table
                            dataSource={commercial_cibil}
                            columns={this.columns}
                            pagination={false}
                        />
                    </Card> : null
                } 
            </React.Fragment>
        );
    }
}

CibilParamTable.propTypes = {
    companyId: PropTypes.number,
    associates: PropTypes.object,
    status: PropTypes.string,
    save: PropTypes.bool,
    update: PropTypes.func,
    CIBIL_EDIT: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    caseId: PropTypes.number,
    attachDocument: PropTypes.func,
    cibilDocuments: PropTypes.array,
    cibilParamData: PropTypes.array,
    company: PropTypes.object,
    caseDetails: PropTypes.object,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default (CibilParamTable);
